module.exports = __webpack_public_path__ + "assets/img/back.ae60c2be.png";